<div class="title" *ngIf="params.title" [ngStyle]="params.titleStyle">
  <span (click)="titleClick()">
    {{params.title}}
  </span>
  <ng-content select="[formTitle]"></ng-content>
</div>

<div class="subtitle" *ngIf="params.subtitle" [ngStyle]="params.subTitleStyle">
  <div [innerHTML]="params.subtitle"></div>
  <ng-content select="[formSubTitle]"></ng-content>
</div>

<ng-content select="[beforeForm]"></ng-content>

<form class="dynamic-form" [ngClass]="formClasses" [ngStyle]="params.formStyle" [formGroup]="form"
  (submit)="onSubmit($event)">
  <ng-container gioFormTemplate [service]="service" [form]="form">
  </ng-container>
</form>

<ng-content select="[afterForm]"></ng-content>


<!-- Fab action buttons -->
<ng-container *ngIf="params.actionButtons && params.actionButtons === 'fab' && !params.buttons">
  <button *ngIf="(service.state | async) === 'edit' || !params.editable" mat-fab class="fab-bl" color="warn"
    (click)="cancel()">
    <mat-icon>clear</mat-icon>
  </button>

  <button *ngIf="(service.state | async) === 'edit'" mat-fab class="fab-br" color="primary" (click)="save()">
    <mat-icon>check</mat-icon>
  </button>

  <button *ngIf="(service.state | async) === 'idle' && params.editable" mat-fab class="fab-br" color="primary"
    (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>

</ng-container>

<div class="form-actions" *ngIf="params.actionButtons && params.actionButtons === 'raised' && !params.buttons">
  <button *ngIf="(service.state | async) === 'edit' || !params.editable" mat-raised-button color="warn"
    (click)="cancel()">
    <mat-icon>clear</mat-icon>
  </button>

  <button *ngIf="(service.state | async) === 'edit'" mat-raised-button color="primary" (click)="save()">
    <mat-icon>check</mat-icon>
  </button>

  <button *ngIf="(service.state | async) === 'idle' && params.editable" mat-raised-button color="primary"
    (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>
</div>

<div class="form-actions" *ngIf="params.actionButtons && params.actionButtons.inArray(['flat','text']) && !params.buttons">
  <button *ngIf="(service.state | async) === 'edit' || !params.editable" mat-button color="warn"
    (click)="cancel()">
    {{params.cancelButtonLabel}}
  </button>

  <button *ngIf="(service.state | async) === 'edit'" mat-button color="primary" (click)="save()">
    {{params.submitButtonLabel}}
  </button>

  <button *ngIf="(service.state | async) === 'idle' && params.editable" mat-button color="primary"
    (click)="edit()">
    {{params.editButtonLabel}}

  </button>
</div>


<div class="form-actions" [ngClass]="params.actionButtonsStyle" *ngIf="params.buttons">
  <ng-container *ngFor="let _button of params.buttons">
    <ng-container *ngIf="_button._isVisible" [service]=service [field]=_button [group]="form" gioFormField></ng-container>
  </ng-container>

</div>



